// import { legacy_createStore as  createStore, combineReducers, applyMiddleware } from "redux";
// import ReduxThunk from 'redux-thunk';
// import AuthReducer from "./reducers/AuthReducer";

// //reducers

// const store = combineReducers({
//     auth: AuthReducer,
// });

// const middlewareStore = applyMiddleware (ReduxThunk)(createStore)
// export default middlewareStore(store,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() );


import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/AuthReducer"; // Adjust path based on your file structure

const store = configureStore({
    reducer: {
        auth: authReducer
    },
});

export default store;
